export const searchModule = {

    state() {
        return {
            results: []
        }
    },

    getters: {
        results(state) {
            return state.results
        }
    },

    mutations: {
        setResults(state, data) {
            state.results = data
        },
    },

    actions: {
        async getSearchResults({ commit }, query) {
            await axios.get('/api/products/search/' + query).then((res) => {
                commit('setResults', res.data.data);
            }).catch((err) => {

            })
        }
    },

    namespaced: true,
}